module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self",
    style: ({
      overflow: _vm.viewUseFullscreen ? 'hidden' : null
    })
  }, [_c('HeaderBar', {
    staticClass: "application__header"
  }), _c('MainMenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewUseFullscreen),
      expression: "!viewUseFullscreen"
    }],
    staticClass: "header"
  }), _c('div', {
    staticClass: "content"
  }, [_c('course-run', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.name === 'step'),
      expression: "this.$route.name === 'step'"
    }]
  }), _c('create-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.name === 'create'),
      expression: "this.$route.name === 'create'"
    }]
  }), _c('execute', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.name === 'execute'),
      expression: "this.$route.name === 'execute'"
    }]
  }), _c('keep-alive', [(_vm.$route.meta.keepAlive === undefined || _vm.$route.meta.keepAlive) ? _c('router-view', {
    key: _vm.viewId,
    attrs: {
      "id": _vm.viewId
    }
  }) : _vm._e()], 1), (_vm.$route.meta.keepAlive !== undefined && !_vm.$route.meta.keepAlive) ? _c('router-view', {
    key: _vm.viewId,
    attrs: {
      "id": _vm.viewId
    }
  }) : _vm._e()], 1), _c('footer-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewUseFullscreen),
      expression: "!viewUseFullscreen"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24d60c45!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Application.vue
// module id = 587
// module chunks = 2